import type { ChatSource } from "@src/features/ai/components/WorkflowEditor/execution/types";
import { getAiChat, handleAiChatAction } from "@src/store/slices/aiChat";

/** The chat every overlay shares: one open at a time, each clearing it when it closes. */
export const SHARED_CHAT: ChatSource = {
  select: getAiChat,
  apply: handleAiChatAction,
};
